import http, { createApi } from '@core/fetch'

export default {
  // http://doc.hunliji.com/workspace/myWorkspace.do?projectId=32#2095
  showCaseListApi: createApi(
    '/p/wedding/index.php/Admin/APIMerchantRecommendMeal/lists'
  ),
  productCoupon: createApi(
    '/p/wedding/index.php/Admin/APIMerchantCouponBuyers/DifferentProductCouponList'
  ),
  //获取图片安全地址
  getSafeImg: createApi('/p/wedding/Home/APIUtils/timestamp_antileech_url'),

  getAllAreaApi: () => http('/p/wedding/shop/APIShopAddress/AllAddress'),

  getCityApi: () => http('/p/admin/index.php/home/SubPage/GetProviceCity'),
  // 获取微信公众号二维码
  getWechatQRCode: () =>
    http('/hms/hljMerchantCenter/appApi/wxBiz/qrcode/attention/hljMerchant'),
  // 根据指南id运营后台配置的新人指南
  getGuide: guideId =>
    http('/hms/light/adminApi/merchantTask/courseGuideByGuideId', {
      body: { guideId }
    })
}
